import React, { useState, useEffect } from 'react';
import { tasksAPI } from '../../services/api';
import { StatCard } from '../../components/common/StatCard';
import { PageHeader } from '../../components/layout/PageHeader';
import { Badge } from '../../components/common/Badge';
import { useAuth } from '../../context/AuthContext';
import { CheckCircleIcon, ClockIcon, FireIcon, QueueListIcon } from '@heroicons/react/24/outline';
import { format } from 'date-fns';

export function EmployeeDashboard() {
  const { user } = useAuth();
  const [tasks, setTasks]   = useState([]);
  const [stats, setStats]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.allSettled([tasksAPI.getAll({ limit:8 }), tasksAPI.getStats()])
      .then(([t,s]) => {
        if (t.status==='fulfilled') setTasks(t.value.data||[]);
        if (s.status==='fulfilled') setStats(s.value.data||[]);
      })
      .finally(() => setLoading(false));
  }, []);

  const get = (k) => (stats.find(s=>s._id===k)||{}).count || 0;
  const total = stats.reduce((s,t)=>s+t.count,0);

  return (
    <div className="space-y-6">
      <PageHeader title={'Hello, ' + (user?.name?.split(' ')[0]||'')} subtitle="Your task overview for today"/>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard title="Total Tasks"  value={loading?'...':total}              icon={QueueListIcon}   color="indigo"/>
        <StatCard title="In Progress"  value={loading?'...':get('in-progress')} icon={ClockIcon}       color="blue"/>
        <StatCard title="Completed"    value={loading?'...':get('done')}        icon={CheckCircleIcon} color="green"/>
        <StatCard title="Urgent"       value={loading?'...':get('urgent')}      icon={FireIcon}        color="red"/>
      </div>
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
        <h3 className="font-semibold text-gray-800 mb-4 text-sm">Recent Tasks</h3>
        {tasks.length===0 ? <p className="text-gray-400 text-sm text-center py-8">No tasks assigned yet</p> : (
          <div className="space-y-2">
            {tasks.map(task => (
              <div key={task._id} className="flex items-center gap-3 p-3 rounded-xl hover:bg-gray-50 transition-colors">
                <div className={'w-2 h-2 rounded-full flex-shrink-0 ' + ({urgent:'bg-red-500',high:'bg-orange-500',medium:'bg-yellow-500',low:'bg-green-500'}[task.priority]||'bg-gray-300')}/>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate">{task.title}</p>
                  <p className="text-xs text-gray-400">{task.project?.name||'General'}</p>
                </div>
                <Badge status={task.status}/>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}